import { MatDialog } from "@angular/material";
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { DashboardService } from '../services/dashboard.service';
import { BoModule, BoModuleGroup } from '../services/bomodule';
import { LanguageModalComponent } from '../../shared/languageModal/components/scripts/languageModal.component';
import { AuthService } from '../../authentication/services/auth.service';

const CANCEL: string = 'cancel';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  modules: BoModuleGroup[] = [];

  constructor(private dashboardService: DashboardService,
    private dialog: MatDialog,
    private authService: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.getModules();
  }

  getModules(): void {
    this.dashboardService.getModules()
      .subscribe(modules => this.modules = modules);
  }

  moduleClick(moduleSelected: BoModule): void {
    if(!moduleSelected.isActive)
      return;
    if (moduleSelected.isMultiLanguage) {
      var userLanguages = this.authService.getUserLanguages();
      if (userLanguages && userLanguages.length === 1) {
        this.authService.setLanguage(userLanguages[0]);
        this.redirect(moduleSelected);
      } else {
        this.selectLanguage(userLanguages, moduleSelected);
      }
    }
    else {
      this.redirect(moduleSelected);
    }
  }

  redirect(moduleSelected: BoModule) {
    if (moduleSelected.routed) {
      this.router.navigateByUrl(moduleSelected.url);
    }
    else {
      window.location.href = '/#' + moduleSelected.url;
    }
  }

  selectLanguage(userLanguages: any, moduleSelected: BoModule) {
    this.dialog.open(LanguageModalComponent, {
      hasBackdrop: true,
      backdropClass: 'fxstreet-modal-backdrop',
      panelClass: 'fxstreet-preview-dialog-panel',
      data: {
        CancelResult: CANCEL,
        Languages: userLanguages
      }
    }).afterClosed().subscribe(result => {
      if (result && result !== CANCEL) {
        this.authService.setLanguage(result);
        this.redirect(moduleSelected);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/components/dashboard.component.ts